import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=567c249e&scoped=true"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"
import style0 from "./notice.vue?vue&type=style&index=0&id=567c249e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567c249e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567c249e')) {
      api.createRecord('567c249e', component.options)
    } else {
      api.reload('567c249e', component.options)
    }
    module.hot.accept("./notice.vue?vue&type=template&id=567c249e&scoped=true", function () {
      api.rerender('567c249e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/studentMessageCenter/notice.vue"
export default component.exports